import { customAlphabet } from "nanoid";

const BASE62_CHARS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const generateSuffix = customAlphabet(BASE62_CHARS, 5);

export function generateRandomKey(suffix: string = generateSuffix()): string {
  // UNIXエポックタイム(経過0.1秒)のBase36 + ランダムBase62(5文字)
  return Math.floor(Date.now() / 100).toString(36) + suffix;
}
